import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, PhoneIcon, VideoIcon, CameraIcon, CheckCheckIcon, SmileIcon, MicIcon, PaperclipIcon, MoreVerticalIcon } from 'lucide-react';
function WhatsAppHeader({
  name,
  status = 'en línea'
}: {
  name: string;
  status?: string;
}) {
  return <div className="flex items-center px-2 py-2 gap-2" style={{
    backgroundColor: '#075E54'
  }} data-id="element-194">
      <ArrowLeftIcon className="w-5 h-5 text-white/90 flex-shrink-0" data-id="element-195" />
      <div className="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0" style={{
      backgroundColor: '#128C7E'
    }} data-id="element-196">
        {name.charAt(0)}
      </div>
      <div className="flex-1 min-w-0" data-id="element-197">
        <p className="text-white text-sm font-medium leading-tight truncate" data-id="element-198">
          {name}
        </p>
        <p className="text-white/70 text-[11px] leading-tight" data-id="element-199">{status}</p>
      </div>
      <div className="flex items-center gap-3 flex-shrink-0" data-id="element-200">
        <VideoIcon className="w-5 h-5 text-white/90" data-id="element-201" />
        <PhoneIcon className="w-5 h-5 text-white/90" data-id="element-202" />
        <MoreVerticalIcon className="w-5 h-5 text-white/90" data-id="element-203" />
      </div>
    </div>;
}
function DateSeparator({
  text
}: {
  text: string;
}) {
  return <div className="flex justify-center my-3" data-id="element-204">
      <span className="text-[11px] px-3 py-1 rounded-lg shadow-sm" style={{
      backgroundColor: '#E1F2FB',
      color: '#54656F'
    }} data-id="element-205">
        {text}
      </span>
    </div>;
}
function ReceivedBubble({
  children,
  time
}: {
  children: React.ReactNode;
  time: string;
}) {
  return <div className="flex justify-start px-3 mb-1" data-id="element-206">
      <div className="relative max-w-[85%] rounded-lg rounded-tl-none px-2.5 pt-1.5 pb-1 shadow-sm" style={{
      backgroundColor: '#FFFFFF'
    }} data-id="element-207">
        <p className="text-[13.5px] leading-[19px] pr-12" style={{
        color: '#111B21'
      }} data-id="element-208">
          {children}
        </p>
        <span className="absolute bottom-1 right-2 text-[10.5px] leading-none" style={{
        color: '#667781'
      }} data-id="element-209">
          {time}
        </span>
      </div>
    </div>;
}
function SentBubble({
  children,
  time
}: {
  children: React.ReactNode;
  time: string;
}) {
  return <div className="flex justify-end px-3 mb-1" data-id="element-210">
      <div className="relative max-w-[85%] rounded-lg rounded-tr-none px-2.5 pt-1.5 pb-1 shadow-sm" style={{
      backgroundColor: '#DCF8C6'
    }} data-id="element-211">
        <p className="text-[13.5px] leading-[19px] pr-14" style={{
        color: '#111B21'
      }} data-id="element-212">
          {children}
        </p>
        <span className="absolute bottom-1 right-2 flex items-center gap-0.5 text-[10.5px] leading-none" style={{
        color: '#667781'
      }} data-id="element-213">
          {time}
          <CheckCheckIcon className="w-[15px] h-[15px] ml-0.5" style={{
          color: '#53BDEB'
        }} data-id="element-214" />
        </span>
      </div>
    </div>;
}
function PhotoMessage({
  time,
  src
}: {
  time: string;
  src: string;
}) {
  return <div className="flex justify-start px-3 mb-1" data-id="element-215">
      <div className="relative rounded-lg rounded-tl-none overflow-hidden shadow-sm" style={{
      backgroundColor: '#FFFFFF'
    }} data-id="element-216">
        <img src={src} alt="Foto enviada" className="w-48 h-36 object-cover" data-id="element-217" />
        <div className="absolute bottom-1 right-2 flex items-center gap-1 bg-black/40 backdrop-blur-sm rounded-full px-1.5 py-0.5" data-id="element-218">
          <span className="text-[10px] text-white" data-id="element-219">{time}</span>
        </div>
      </div>
    </div>;
}
function ChatInputBar() {
  return <div className="flex items-center gap-1.5 px-2 py-1.5" style={{
    backgroundColor: '#F0F2F5'
  }} data-id="element-220">
      <SmileIcon className="w-5 h-5 flex-shrink-0" style={{
      color: '#54656F'
    }} data-id="element-221" />
      <PaperclipIcon className="w-5 h-5 flex-shrink-0" style={{
      color: '#54656F'
    }} data-id="element-222" />
      <div className="flex-1 rounded-full px-3 py-1.5 text-[13px]" style={{
      backgroundColor: '#FFFFFF',
      color: '#8696A0'
    }} data-id="element-223">
        Mensaje
      </div>
      <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{
      backgroundColor: '#00A884'
    }} data-id="element-224">
        <MicIcon className="w-4 h-4 text-white" data-id="element-225" />
      </div>
    </div>;
}
const chatWallpaper = {
  backgroundColor: '#ECE5DD',
  backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23c9c2b8' fill-opacity='0.15'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
};
function ScreenshotFrame({
  children,
  index
}: {
  children: React.ReactNode;
  index: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-40px'
  }} transition={{
    delay: index * 0.15,
    duration: 0.5,
    ease: 'easeOut'
  }} className="mx-auto w-full max-w-[320px]" data-id="element-226">
      <div className="rounded-2xl overflow-hidden shadow-2xl shadow-black/15 border border-gray-200/60" data-id="element-227">
        {children}
      </div>
    </motion.div>;
}
export function TestimonialsSection() {
  return <section className="py-20 bg-cream" data-id="element-228">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
        {/* Section Header */}
        <div className="text-center mb-14" data-id="element-230">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif font-bold text-dark" data-id="element-231">
            Lo que dicen nuestras clientas
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="mt-4 text-lg text-muted" data-id="element-232">
            Capturas reales de conversaciones
          </motion.p>
        </div>

        {/* Screenshot Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-6 items-start" data-id="element-233">
          {/* ===== CHAT 1 — Cristina (moldes fáciles + primera venta) ===== */}
          <ScreenshotFrame index={0} data-id="element-234">
            <WhatsAppHeader name="Cristina" data-id="element-235" />
            <div className="py-2" style={{
            ...chatWallpaper,
            minHeight: '370px',
            maxHeight: '370px',
            overflow: 'hidden'
          }} data-id="element-236">
              <DateSeparator text="Hoy" data-id="element-237" />

              <ReceivedBubble time="10:14 a.m." data-id="element-238">
                Hola! 😍 Quería contarte algo
              </ReceivedBubble>

              <ReceivedBubble time="10:14 a.m." data-id="element-239">
                Acabo de hacer mi PRIMERA VENTA con los moldes
              </ReceivedBubble>

              <ReceivedBubble time="10:15 a.m." data-id="element-240">
                ¡¡¡No lo puedo creer!!!
              </ReceivedBubble>

              <SentBubble time="10:17 a.m." data-id="element-241">
                ¡¡Felicidades Cris!! 🎉🎉 ¿Qué hiciste?
              </SentBubble>

              <ReceivedBubble time="10:18 a.m." data-id="element-242">
                Un nombre en alambre para un baby shower
              </ReceivedBubble>

              <ReceivedBubble time="10:18 a.m." data-id="element-243">
                Me pagaron $45 dólares 😭🙌
              </ReceivedBubble>

              <ReceivedBubble time="10:19 a.m." data-id="element-244">
                Los moldes son TAN fáciles de seguir que lo hice en una tarde
              </ReceivedBubble>

              <SentBubble time="10:20 a.m." data-id="element-245">
                Eso es INCREÍBLE 💪 ¿Ves que sí se puede?
              </SentBubble>

              <ReceivedBubble time="10:22 a.m." data-id="element-246">
                Siii y ya me pidieron 3 más para la semana que viene
              </ReceivedBubble>

              <ReceivedBubble time="10:23 a.m." data-id="element-247">
                Gracias por todo 🥺❤️
              </ReceivedBubble>
            </div>
            <ChatInputBar data-id="element-248" />
          </ScreenshotFrame>

          {/* ===== CHAT 2 — Sandra (variedad de moldes + negocio) ===== */}
          <ScreenshotFrame index={1} data-id="element-249">
            <WhatsAppHeader name="Sandra" data-id="element-250" />
            <div className="py-2" style={{
            ...chatWallpaper,
            minHeight: '370px',
            maxHeight: '370px',
            overflow: 'hidden'
          }} data-id="element-251">
              <DateSeparator text="Ayer" data-id="element-252" />

              <ReceivedBubble time="3:42 p.m." data-id="element-253">
                Mira lo que hice esta semana 🥹
              </ReceivedBubble>

              <PhotoMessage time="3:42 p.m." src="https://cdn.magicpatterns.com/uploads/h5ekKQC8frah9B8WE3LvNb/Eu_sou_mae_de_pet_🐶_e_tambem_sou_artesa_✂️🧶__Essa_foto_e_minha,_com_o_pug_que_adotamos_ha_4_anos_(Zyon)_—_um_amor_que_virou_parte_da_nossa_familia_ao_lado_de_mais_dois__Zoey_(pug)_e_Zeus_(buldogue)_🐾💞__Cada_det.jpg" data-id="element-254" />

              <ReceivedBubble time="3:43 p.m." data-id="element-255">
                Nombres, flores, figuras de navidad...
              </ReceivedBubble>

              <ReceivedBubble time="3:43 p.m." data-id="element-256">
                Hay moldes de TODO literal 😍
              </ReceivedBubble>

              <SentBubble time="3:45 p.m." data-id="element-257">
                ¡WOW Sandra! 😱 Qué bonito todo
              </SentBubble>

              <SentBubble time="3:45 p.m." data-id="element-258">¿Cuál te gustó más?</SentBubble>

              <ReceivedBubble time="3:47 p.m." data-id="element-259">
                Las lámparas! Son las que más me piden jaja
              </ReceivedBubble>

              <ReceivedBubble time="3:48 p.m." data-id="element-260">
                Lo mejor es que cada molde trae las medidas exactas
              </ReceivedBubble>

              <SentBubble time="3:49 p.m." data-id="element-261">
                Nos encanta ver estos resultados 🫶
              </SentBubble>
            </div>
            <ChatInputBar data-id="element-262" />
          </ScreenshotFrame>

          {/* ===== CHAT 3 — Pamela (fácil de seguir + regalo) ===== */}
          <ScreenshotFrame index={2} data-id="element-263">
            <WhatsAppHeader name="Pamela" data-id="element-264" />
            <div className="py-2" style={{
            ...chatWallpaper,
            minHeight: '370px',
            maxHeight: '370px',
            overflow: 'hidden'
          }} data-id="element-265">
              <DateSeparator text="Hoy" data-id="element-266" />

              <ReceivedBubble time="8:05 p.m." data-id="element-267">
                Buenas! Quería darte las gracias 🙏
              </ReceivedBubble>

              <ReceivedBubble time="8:05 p.m." data-id="element-268">
                Yo no sabía NADA de tricotín
              </ReceivedBubble>

              <ReceivedBubble time="8:06 p.m." data-id="element-269">
                Pero los moldes son tan claros que lo entendí a la primera
              </ReceivedBubble>

              <SentBubble time="8:08 p.m." data-id="element-270">
                Qué alegría Pame! 💚 ¿Qué fue lo primero que hiciste?
              </SentBubble>

              <ReceivedBubble time="8:09 p.m." data-id="element-271">
                Un nombre para mi sobrina que cumplía años
              </ReceivedBubble>

              <ReceivedBubble time="8:10 p.m." data-id="element-272">
                Mi hermana lloró cuando lo vio jaja 😭
              </ReceivedBubble>

              <ReceivedBubble time="8:10 p.m." data-id="element-273">
                Ahora quiero hacer las flores y los bolígrafos también
              </ReceivedBubble>

              <SentBubble time="8:12 p.m." data-id="element-274">
                Hay moldes para todo eso y mucho más 🤗
              </SentBubble>

              <ReceivedBubble time="8:14 p.m." data-id="element-275">
                Mejor compra que he hecho! 💕
              </ReceivedBubble>
            </div>
            <ChatInputBar data-id="element-276" />
          </ScreenshotFrame>
        </div>
      </div>
    </section>;
}